import { render } from "./InstructorHome.vue?vue&type=template&id=f0624cfe&scoped=true"
import script from "./InstructorHome.vue?vue&type=script&lang=js"
export * from "./InstructorHome.vue?vue&type=script&lang=js"

import "./InstructorHome.vue?vue&type=style&index=0&id=f0624cfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0624cfe"]])

export default __exports__